import './App.css';
import HomeComponent from './components/HomeComponent/Home';
import BannerComponent from './components/BannerCOmponent/BannerComponent';
import AboutUsComponent from './components/AboutUsComponent/AboutUsComponent';
import MenuComponent from './components/MenuComponent/MenuComponent';
import Carousel from './components/ImageListComponent/ImageListComponent';
// import SpecialsComponent from './components/SpecialsComponent/SpecialsComponent';
import MapContainerComponent from './components/MapContainer/MapContainer';
import FooterComponent from './components/FooterComponent/FooterComponent';
import OpeningHoursComponent from './components/OpeningHoursComponent/OpeningHoursComponent';
import NavbarMobile from './components/Navbar/NavbarMobile';
import CookieConsent from "react-cookie-consent";

function App() {
  return (
    <div className="App">

      <BannerComponent />
      <AboutUsComponent />
      <MenuComponent />
      {/* <SpecialsComponent /> */}
      <Carousel />
      <OpeningHoursComponent />
      <MapContainerComponent />
      <FooterComponent />
      <div className='tw-block md:tw-hidden lg:tw-hidden bottom-right'>
        <NavbarMobile className="absolute inset-x-0 bottom-0" />
      </div>
      <CookieConsent
        location="bottom"
        buttonText="I Understand"
        cookieName="kakariki"
        style={{ background: "#2B373B" }}
        buttonStyle={{ backgroundColor: "#91a174", color: "#ffffff", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </div>

  );
}

export default App;
